// extracted by mini-css-extract-plugin
module.exports = {"twin-spin":"TwinSpin_twin-spin__PAbzQ","spin":"TwinSpin_spin__1Zw2N","pulse":"TwinSpin_pulse__2tpYZ"};